<div class="request-more-store-insight-form-page-container container" [formGroup]="form">
  <p>{{ 'requestMoreInsight.helpText' | translate }}</p>
  <p>{{ 'requestMoreInsight.interestQuestion' | translate }}</p>

  <div class="checkboxes-container container">
    <div class="checkbox-container" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
      <mat-checkbox color="primary" formControlName="groceryPotentialStudy">
        {{ 'requestMoreInsight.groceryPotentialStudy' | translate }}
      </mat-checkbox>
      <mtn-what-is-this text="{{ 'requestMoreInsight.groceryPotentialStudyInfo' | translate }}"></mtn-what-is-this>
    </div>

    <div class="checkbox-container" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
      <mat-checkbox color="primary" formControlName="assetReview">
        {{ 'requestMoreInsight.assetReview' | translate }}
      </mat-checkbox>
      <mtn-what-is-this text="{{ 'requestMoreInsight.assetReviewInfo' | translate }}"></mtn-what-is-this>
    </div>

    <div class="checkbox-container" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
      <mat-checkbox color="primary" formControlName="salesForecastReport">
        {{ 'requestMoreInsight.salesForecastReport' | translate }}
      </mat-checkbox>
      <mtn-what-is-this text="{{ 'requestMoreInsight.salesForecastReportInfo' | translate }}"></mtn-what-is-this>
    </div>

    <div class="checkbox-container" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
      <mat-checkbox color="primary" formControlName="other">
        {{ 'requestMoreInsight.other' | translate }}
      </mat-checkbox>
    </div>
  </div>

  <br/><br/>

  <div>
    <div fxLayout="row" fxLayoutGap="15px">
      <mtn-email-address-field [form]="form" placeholder="{{ 'requestMoreInsight.emailPlaceholder' | translate }}">
      </mtn-email-address-field>
      <mtn-phone-number-field [form]="form" placeholder="{{ 'requestMoreInsight.phonePlaceholder' | translate }}">
      </mtn-phone-number-field>
    </div>
    <mtn-text-area-field [form]="form" controlName="message"
                         placeholder="{{ 'requestMoreInsight.messagePlaceholder' | translate }}"
                         maxLength="500"></mtn-text-area-field>
  </div>
</div>
